import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';

const UnarchiveAlertActions = ({ alert, clickHandler, isArchiving }) => {
  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      <Tooltip title="Unarchive" arrow placement="right">
        <IconButton
          onClick={() => clickHandler(alert.id)}
          size="small"
          disabled={isArchiving}
          sx={{
            '&:hover': {
              backgroundColor: 'action.hover',
              color: 'primary.main',
            },
            transition: 'all 0.2s',
          }}
        >
          <UndoIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default UnarchiveAlertActions;
